import CandidateSearch from './img/candidate-search.png';
import Location from './img/location.png';
import MultipleCandidates from './img/multiple-candidates.png';

export const pageIntroData = {
  title: 'Create your QR code ad to connect with more people, in more places',
  summary:
    'use your personalised job ad QR code in your shopfront to help more candidates find and apply for for your role.',
};

export interface Promo {
  icon: HTMLImageElement;
  text: string;
}
export const promoTileData: Promo[] = [
  {
    icon: MultipleCandidates,
    text: 'Drive more visits to your job ad by sharing it in online and offline channels.',
  },
  {
    icon: Location,
    text: 'Utilise your shopfront, office or physical space to promote your job ad.​',
  },
  {
    icon: CandidateSearch,
    text: 'Potential candidates can scan and view your job ad in seconds.',
  },
];

export const stepsList = [
  'Hit the ‘Create QR code poster’ button above to generate your personalised job ad QR code poster',
  'Print your QR code poster',
  'Display your QR code poster in high traffic areas to promote your job ad',
  'Take down your QR code poster when your job ad expires',
];
